import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
          {aboutData.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-3xl mx-auto">
          {aboutData.content}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {aboutData.highlights.map((item, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-800 text-xs md:text-sm font-medium whitespace-nowrap"
            >
              <i className="ri-check-line mr-1.5"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}